//import { ErrorFaultState } from "context/ErrorFaultContext";
import { AddErrorFault } from "models/ErrorFault";

export default function errorFaultHelper(title:string, type:string, message:string, error:unknown) {
    const storage = JSON.parse(localStorage.getItem('errorfaultdata') || '{}');
    const id = Math.floor(Math.random() * 100);
    const errorLogging:AddErrorFault = {
        id: id,
        title: title,
        message: message,
        type: type,
        error: JSON.stringify(error)
    }

    storage[id] = errorLogging;
    localStorage.setItem('errorfaultdata', JSON.stringify(storage));
    
    //const { stateErrorFault } = ErrorFaultState();
    
    // const request:ErrorFault = {
    //     id: Math.floor(Math.random() * 100),
    //     message: message !== null ? message : "Error message unknown",
    //     title: title !== null ? title : "Error title unknown",
    //     type: type !== null ? type : "alert",
    //     error: JSON.stringify(error)
    // }

    //stateErrorFault.addError(request);
}